import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { UserAccessors, UserSelectors } from '@dtna/dvs-support-dcp-shared-state/lib/selectors/user.selector';

import isFuelPageEnabled from 'utils/isFuelPageEnabled';
import getFeatureFlags from '../services/featureFlag';
import useClarityWatcher from '../hooks/useClarityWatcher';
import useTelemetry from '../hooks/useTelemetry';
import NavbarWrapper from './wrappers/NavbarWrapper';
import Layout from './Layout';
import LegacyWrapper from './wrappers/LegacyWrapper';
import useFetchUserData from '../hooks/useFetchUserData';
import useGtmLocationWatcher from '../hooks/useGtmLocationWatcher';
import useHomePageRedirectWatcher from '../hooks/useHomePageRedirectWatcher';
import { useHostSelector } from '../store';
import HOST_ROUTE_TABLE from '../constants/routes';
import Toasts from './Toasts';
import MaintenanceWrapper from './wrappers/VehicleMaintenanceWrapper';
import GeofencingWrapper from './wrappers/GeofencingWrapper';
import EServicesIndexWrapper from './wrappers/EServicesIndexWrapper';
import VehicleHealthIndexWrapper from './wrappers/VehicleHealthIndexWrapper';
import FuelIndexWrapper from './wrappers/FuelIndexWrapper';
import RemoteUpdatesPremiumWrapper from './wrappers/RemoteUpdatesPremiumWrapper';
import XOTAIndexWrapper from './wrappers/XOTAIndexWrapper';

export default function HostRouter() {
  const userIsSignedIn = useHostSelector(UserSelectors.selectUserIsSignedIn);
  const customer = useHostSelector(UserSelectors.selectCustomer);
  const isFuelAnalyticsEnabled = useHostSelector(UserAccessors.getFuelAnalyticsEnabled);
  const userEmail = useHostSelector(UserAccessors.getUserEmail);
  const [navbarLoaded, setNavbarLoaded] = useState(false);

  useFetchUserData();
  useGtmLocationWatcher();
  useClarityWatcher();
  useHomePageRedirectWatcher();
  useTelemetry();

  useEffect(() => {
    if (userIsSignedIn && customer && userEmail) {
      getFeatureFlags({ tan: customer.Tan, userEmail });
    }
  }, [userIsSignedIn]);

  return (
    <>
      <NavbarWrapper onLoad={() => setNavbarLoaded(true)} />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path={`${HOST_ROUTE_TABLE.LEGACY.VEHICLE_HEALTH_CIAM}/*`} element={<VehicleHealthIndexWrapper navbarLoaded={navbarLoaded} />} />
          <Route index element={<LegacyWrapper navbarLoaded={navbarLoaded} />} />
          <Route path={`${HOST_ROUTE_TABLE.HOST.LEGACY}/*`} element={<LegacyWrapper navbarLoaded={navbarLoaded} />} />
          {
            userIsSignedIn && (
              <>
                <Route path={`${HOST_ROUTE_TABLE.LEGACY.MAINTENANCE}/*`} element={<MaintenanceWrapper navbarLoaded={navbarLoaded} />} />
                <Route path={`${HOST_ROUTE_TABLE.LEGACY.GEOFENCING}/*`} element={<GeofencingWrapper navbarLoaded={navbarLoaded} />} />
                <Route path={`${HOST_ROUTE_TABLE.ESERVICES.E_ROOT}/*`} element={<EServicesIndexWrapper navbarLoaded={navbarLoaded} />} />
                <Route path={`${HOST_ROUTE_TABLE.LEGACY.REMOTE_UPDATES_PREMIUM}/*`} element={<RemoteUpdatesPremiumWrapper navbarLoaded={navbarLoaded} />} />
                <Route path={`${HOST_ROUTE_TABLE.LEGACY.VEHICLE_HEALTH}/*`} element={<VehicleHealthIndexWrapper navbarLoaded={navbarLoaded} />} />
                <Route path={`${HOST_ROUTE_TABLE.LEGACY.VTDash}/*`} element={<VehicleHealthIndexWrapper navbarLoaded={navbarLoaded} />} />
                <Route path={`${HOST_ROUTE_TABLE.XOTA.ROOT}/*`} element={<XOTAIndexWrapper navbarLoaded={navbarLoaded} />} />

                {
                  isFuelPageEnabled(isFuelAnalyticsEnabled) && (<Route path={`${HOST_ROUTE_TABLE.FUEL_ANALYTICS.ROOT}/*`} element={<FuelIndexWrapper navbarLoaded={navbarLoaded} />} />)
                }
              </>
            )
          }
          <Route path="*" element={<LegacyWrapper navbarLoaded={navbarLoaded} />} />
        </Route>
      </Routes>
      <Toasts />
    </>
  );
}
